import styled, { keyframes } from 'styled-components';
import { PHONE_BREAK, Z_INDEX_TOP } from '#/shared/constants';
import SvgUrgentHelpCircle from '#/svg-assets/trimet/urgent-help-circle.svg';
import BaseInfoIcon from '#/svg-assets/trimet/info.svg';
import CircleProgressbarBase from '#/shared/components/CircleProgressbar';
import Button from '#/component-lib/Button';
import BaseCloseIcon from '#/svg-assets/generic/close.svg';
import WarningSvg from '#/svg-assets/trimet/alert.svg';

interface SoftToastWrapperProps {
  visible: boolean;
}

const ICON_SIZE = { width: 25, height: 25 };

export const CloseIcon = styled(BaseCloseIcon).attrs({
  ...ICON_SIZE,
})`
  & path:first-child {
    fill: ${props => props.theme.toastCloseFill};
  }
`;

export const CloseButton = styled(Button)`
  position: relative;
  width: 32px;
  height: 32px;
  margin: 0.6rem;
  border-radius: 100%;
  cursor: pointer;
  flex-shrink: 0;

  // stack direct child elements and center them relative to the parent
  & > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (any-hover: hover) {
    &:hover {
      box-shadow: none;
    }
    &:hover ${CloseIcon} {
      & path:first-child {
        fill: ${props => props.theme.toastText};
      }
    }
  }
`;

const enter = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const exit = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
  }
`;

export const SoftToastWrapper = styled.div<SoftToastWrapperProps>`
  animation: ${({ visible }) => (visible ? enter : exit)} 0.5s ease-out both;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.cardBg};
  border-radius: 8px;
  color: ${props => props.theme.cardText};
  justify-content: space-between;
  box-shadow: ${props => props.theme.toastCardShadow};
  z-index: ${Z_INDEX_TOP};
  width: 100%;
  overflow: hidden;

  // on desktop let the content determine the width of the toast
  @media (min-width: ${PHONE_BREAK}) {
    width: initial;
  }
`;

export const IconWrapper = styled.div`
  margin: 0 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorIcon = styled(SvgUrgentHelpCircle).attrs(ICON_SIZE)``;

export const WarningIcon = styled(WarningSvg).attrs({
  ...ICON_SIZE,
})``;

export const InfoIcon = styled(BaseInfoIcon).attrs(({ theme }) => ({
  ...ICON_SIZE,
  fill: theme.contentTextDim,
}))``;

export const TextWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 0.75em 0;
  flex: 1 1 auto;
`;

export const CircleProgressbar = styled(CircleProgressbarBase).attrs(
  ({ theme }) => ({
    frontCircleColor: theme.toastCloseFrontCircle,
    backCircleColor: theme.toastCloseBackCircle,
  })
)``;

export const ToasterWrapper = styled.div`
  height: 0;
  width: 0;
`;
